import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from './AuthProvider';

const font = "'DM Sans', sans-serif";
const serif = "'DM Serif Display', serif";

// Loading spinner
function Loading() {
  return (
    <div style={{ minHeight:'100vh', display:'flex', flexDirection:'column', alignItems:'center', justifyContent:'center', fontFamily:font, background:'#0a0a0a' }}>
      <div style={{ width:28, height:28, border:'3px solid rgba(255,255,255,0.08)', borderTopColor:'#5dc1b9', borderRadius:'50%', animation:'tdSpin 0.8s linear infinite', marginBottom:12 }} />
      <p style={{ color:'rgba(255,255,255,0.5)', fontSize:14 }}>Creando tu experiencia...</p>
      <style>{`@keyframes tdSpin { to { transform: rotate(360deg); } }`}</style>
    </div>
  );
}

// Upsell card when membership is too low
function UpsellBlock({ requiredMembership, escritorioPath }) {
  const tierNames = {
    doer: 'Doer',
    spark_seeker: 'Doer',
    momentum_builder: 'Momentum Builder',
    growth_mastermind: 'Growth Mastermind',
    clarity_mentor: 'Clarity Mentor',
    tu_radar: 'Tu Radar',
    onsite_mexico: 'Onsite Growth México',
  };
  const tierPrices = {
    doer: '$139 MXN/mes',
    spark_seeker: '$139 MXN/mes',
    momentum_builder: '$27 USD/mes',
    growth_mastermind: '$44 USD/mes',
    tu_radar: '$599 único',
    clarity_mentor: '$66 USD/sesión',
    onsite_mexico: 'Cotización',
  };
  const name = tierNames[requiredMembership] || requiredMembership;
  const price = tierPrices[requiredMembership] || '';

  return (
    <div style={{ minHeight:'100vh', display:'flex', alignItems:'center', justifyContent:'center', fontFamily:font, padding:'2rem' }}>
      <div style={{ maxWidth:420, textAlign:'center' }}>
        <p style={{ fontSize:36, marginBottom:12 }}>🔒</p>
        <h2 style={{ fontSize:22, fontWeight:400, fontFamily:serif, marginBottom:8 }}>
          Esta sección requiere {name}
        </h2>
        <p style={{ fontSize:14, color:'#666', lineHeight:1.7, marginBottom:24 }}>
          Necesitas la membresía {name} ({price}) para acceder a este contenido.
        </p>
        <a href="/sala" style={{
          display:'inline-block', padding:'12px 28px', fontSize:14, fontWeight:500,
          background:'linear-gradient(135deg, #534AB7, #1D9E75)', color:'#fff',
          border:'none', borderRadius:50, textDecoration:'none', fontFamily:font,
        }}>
          Volver a La Sala
        </a>
      </div>
    </div>
  );
}

// Route that requires authentication
export function RequireAuth({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <Loading />;
  if (!user) return <Navigate to="/" replace />;
  return children;
}

// Route that requires auth + completed onboarding
export function RequireOnboarding({ children }) {
  const { user, loading, profileLoaded, onboardingDone } = useAuth();
  if (loading) return <Loading />;
  if (!user) return <Navigate to="/" replace />;
  if (!profileLoaded) return <Loading />;
  if (!onboardingDone) return <Navigate to="/arbol" replace />;
  return children;
}

// Route that requires a specific membership level
export function RequireMembership({ children, minimum }) {
  const { user, loading, profileLoaded, onboardingDone, hasAccess } = useAuth();
  if (loading) return <Loading />;
  if (!user) return <Navigate to="/" replace />;
  if (!profileLoaded) return <Loading />;
  if (!onboardingDone) return <Navigate to="/arbol" replace />;
  if (!hasAccess(minimum)) return <UpsellBlock requiredMembership={minimum} />;
  return children;
}
